
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthConfig, AuthService } from "src/app/Services/auth.service";
import { ChatboxService } from "src/app/Services/chatbox.service";
import { ChatUser, Messages } from "src/app/models/chatBox.model";
@Component({
    selector: 'chat-box',
    templateUrl: './chat-box.component.html',
    styleUrls: ['./chat-box.component.css'],
    standalone: false
})
export class AppChatBox implements OnInit {
    public isAuthenticated: boolean = false;
    public authConfig!: AuthConfig;
    public connectedArtistName!: string;
    public connectedArtistImage!: string;
    public chatUsers: ChatUser[] = [];
    public galleryId!: string;
    public artistId!: string;
    public selectedUserId: string = '';
    public onlineUsers: string[] = [];
    public selectedUser: ChatUser | null = null;
    constructor(private authService: AuthService,
        private chatboxService: ChatboxService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.isAuthenticated = this.authService.isAuthenticated();
        this.route.params.subscribe((params) => {
            if (params['id']) {
                this.selectedUserId = params['id'];
            }
            this.getConnectedUsers()
        });

        this.authConfig = this.authService.getAuthConfig();
    }

    private getConnectedUsers() {
        this.chatboxService.getConnectedUsers().subscribe((ChatResponse: ChatUser[]) => {
            this.chatUsers = ChatResponse;
            // If selectedUserId is not provided or not found in chats users
            if (!this.selectedUserId || !this.chatUsers.find(user => user.Id === this.selectedUserId)) {
                // Select the first user by default if available
                if (this.chatUsers.length > 0) {
                    const firstUserId = this.chatUsers[0].Id;
                    this.selectUser(firstUserId);
                }
            } else if (this.selectedUserId) {
                //select the user specified by selectedUserId
                this.selectedUser = this.chatUsers.find(user => user.Id === this.selectedUserId) || null;
            }
        });
    }

    public selectUser(userId: string) {
        this.selectedUserId = userId;
        this.selectedUser = this.chatUsers.find(user => user.Id === userId) || null;
        this.chatUsers.forEach(user => {
            user.isSelected = (user.Id === userId);
        });
    }

    public onNewMessageReceived($event: Messages) {
        var selectedUser = this.chatUsers.find(user => user.Id === $event.ArtistId || user.Id == $event.GalleryId) || null;
        if (selectedUser) {
            selectedUser.Time = $event.SentDate;
            selectedUser.LastMessage = $event.TextMessage;
        }
    }

    filterChatUsers(searchTerm: string) {
        if (searchTerm.trim() !== '') {
            this.chatUsers = this.chatUsers.filter(user => user.Name.toLowerCase().includes(searchTerm.trim().toLowerCase()));
        } else {
            this.getConnectedUsers();
        }
    }

    isUserOnline(userId: string): boolean {
        return this.onlineUsers.includes(userId);
    }

    getFirstSentence(message: string): string {
        if (!message) return '';
        const endOfSentenceIndex = message.indexOf('.') + 1;
        return endOfSentenceIndex > 0 ? message.substring(0, endOfSentenceIndex) : message;
    }

  
}